import FeedPage from '~/pageComponents/FeedPage';
import getPageMetaTagsProps from '~/pageProps/metatags';

export default FeedPage;

export const getServerSideProps = getPageMetaTagsProps({
  title: 'Followed objkts',
  description: 'View all the objkts created by the artists you follow',
});
